import {Box} from "@mui/material";
import icon from "../icon/icon";

const FastIcon = ({name, width, height, style, ...props}: any) => {
    return (
        <Box
            sx={{
                width: width,
                height: height,
                ...style,
            }}
            {...props}
        >
            {icon[name]}
        </Box>
    );
};

export default FastIcon;
